import {
    UnderwriteModel as BaseGUnderwriteModel,
    DataRobot as GDataRobot,
    ApplicationField,
    ResultError as GResultError,
    RiskModel as GBaseRisk,
    DecisionModel as GBaseDecision,
    PriceModel as GBasePrice,
    BidWinRateModel as GBaseBidWinRate,
    DenyRule as GBaseDenyRule,
    ModelType as GModelType,
    ConversionModel as GBaseConversion
} from './models-slice.generated';
// import Models from "../../../store/reducers/history";
//Take out props we dont use for the client
// generic fn that allows type to be null
// type AllowNullOn<D, K extends keyof D> = Omit<D, K> & {
//     D: Pick<D, K>[K] | null;
// };
export type AllModelTypes = Pick<BaseGUnderwriteModel, 'risk' | 'price' | 'denyRules' | 'decision' | 'bidWinRate' | 'conversion'>;
export type BaseDecision = Required<GBaseDecision>;
export type BasePrice = Required<GBasePrice>;
export type BaseRisk = Required<GBaseRisk>;
export type BaseBidWinRate = Required<GBaseBidWinRate>;
export type BaseConversion = Required<GBaseConversion>

type DataRobotModels = Omit<BaseDecision, 'dataRobot'> | Omit<BasePrice, 'dataRobot'> | Omit<BaseRisk, 'dataRobot'> | Omit<BaseBidWinRate, 'dataRobot'>;
// type AllowNull<M extends ALLMODELTYPES> =;

type DataRobotWithNull<T extends DataRobotModels> = T & { dataRobot: GDataRobot | null };
// generic fn that takes in SupportedModelTypes,  and also allows datarobot to be null since the api fails to show for this

type UNUSED_API_PROPS = 'isDeleted';

export type Models =
    | ClientModel<DenyModel>
    | ClientModel<DecisionModel>
    | ClientModel<RiskModel>
    | ClientModel<PriceModel>
    | ClientModel<BidWinRateModel>
    | ClientModel<ConversionModel>
export type GUnderwriteModel = Omit<BaseGUnderwriteModel, UNUSED_API_PROPS>;

// for now this will work but we want to make sure the api type definitions are accurate so we dont have to do this on the client
export type DecisionModel = {
    modelType: 'Decision';
    decision: DataRobotWithNull<Omit<BaseDecision, 'dataRobot'>> | null;
};
export type PriceModel = { modelType: 'Price'; price: DataRobotWithNull<Omit<BasePrice, 'dataRobot'>> | null };
export type DenyModel = {
    modelType: 'Deny';
    denyRules: DenyRule[];
};
export type RiskModel = { modelType: 'Risk'; risk: DataRobotWithNull<Omit<BaseRisk, 'dataRobot'>> | null };
export type BidWinRateModel = { modelType: 'BidWinRate', bidWinRate: DataRobotWithNull<Omit<BaseBidWinRate, 'dataRobot'>> | null};

export type ConversionModel = {
    modelType: 'Conversion';
    conversion: DataRobotWithNull<Omit<BaseConversion, 'dataRobot'>> | null
  };

  

export const isDecisionModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<DecisionModel> => {
    return m.modelType === 'Decision';
};

export const isPriceModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<PriceModel> => {
    return m.modelType === 'Price';
};

export const isDenyModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<DenyModel> => {
    return m.modelType === 'Deny';
};

export const isRiskModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<RiskModel> => {
    return m.modelType === 'Risk';
};

export const isBidWinRateModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<BidWinRateModel> => {
    return m.modelType === 'BidWinRate';
};

export const isConversionModel = (m: Pick<Models, 'modelType'> | Models): m is ClientModel<ConversionModel> => {
    return m.modelType === 'Conversion';
};

export type DenyRule = Required<GBaseDenyRule>;
type ModelTypes = DenyModel | DecisionModel | RiskModel | PriceModel | BidWinRateModel | ConversionModel;
export type ModelType = GModelType;
export type ClientModel<T extends ModelTypes> = Omit<
    Required<GUnderwriteModel>,
    'risk' | 'decision' | 'denyRules' | 'price' | 'bidWinRate' | 'conversion'
> &
    T;

// export type UnderwriteApiModel = Required<GUnderwriteModel> &
//   Omit<
//     GUnderwriteModel,
//     "risk" | "decision" | "denyRules" | "price" | "dataRobot"
//   >;
export type UnderwriteModel = BaseGUnderwriteModel & (DecisionModel | PriceModel | DenyModel | RiskModel | BidWinRateModel | ConversionModel);
export type GetUnderwriteModelsApiResponse = /** status 200 Success */ UnderwriteModel[];
export type GetUnderwriteModelApiResponse = /** status 200 Success */ UnderwriteModel;
export type PostApiV1UnderwritingModelsApiResponse = UnderwriteModel;
export type PostUnderwriteModelApiResponse = /** status 200 Success */ UnderwriteModel;
export type ModelError = Required<GResultError>; // = ResultError
export type GetApiV1UnderwritingModelsErrorsApiResponse = /** status 200 Success */ ModelError[];
// export type GetUnderwriteModelApiArg =
//   GetApiV1UnderwritingModelsByModelIdApiArg;
export type PostUnderwriteModelApiArg = {
    modelId: number;
    underwriteModelUpdate: Models;
};
export type PostApiV1UnderwritingModelsApiArg = Pick<
    PostUnderwriteModelApiArg,
    'underwriteModelUpdate'
>['underwriteModelUpdate'];
export type DataRobot = GDataRobot | null;
export type ApplicationFieldApiModel = Required<ApplicationField>;

export type CapHistory = {
    capId: number;
    name: string;
    amount: number;
    period: number;
    activeStart: Date;
    activeEnd: Date;
    origins: number[];
    states: string[];
    customerTypes: number[];
    startedOn: Date;
    endedOn: Date;
}